import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useMeasurementMineralCreateMutation, useMeasurementMineralFindAllQuery, useMeasurementMineralUpdateMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import measurementSvg from "../../../assets/images/svg/measurement.svg"
import Flatpickr from "react-flatpickr";

const Measurement = () => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)
  const { data, error, isFetching } = useMeasurementMineralFindAllQuery(`?mineral_id=${id}`);
  const [measurementMineralCreate, measurementMineralCreateResult] = useMeasurementMineralCreateMutation();
  const [measurementMineralUpdate, measurementMineralUpdateResult] = useMeasurementMineralUpdateMutation();
  const [measurementMineral, setMeasurementMineral] = useState<any>();

  const [contains_water, setContains_waterBoolean] = useState<boolean>(false);
  const [is_clean, setIs_cleanBoolean] = useState<boolean>(false);
  const [sprint_mode, setSprint_mode] = useState<boolean>(false);

  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);


  const [measurementList, setMeasurementList] = useState<any>();

  const [meaCount, setMeaCount] = useState<any>();


  const {
    data: commonMineral,
    error: commonMineralError,
    isFetching: isCommonMineralFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_mineral_mode`);

  useEffect(() => {

    if (measurementMineral === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }

    setMeasurementList(data?.data);
    setMeaCount(measurementList?.length)
    const tempContains_water = measurementMineral !== null ? measurementMineral?.contains_water : false;
    const tempIs_clean = measurementMineral !== null ? measurementMineral?.is_clean : false;
    const tempSprint_mode = measurementMineral !== null ? measurementMineral?.sprint_mode : false;
    setContains_waterBoolean(tempContains_water)
    setIs_cleanBoolean(tempIs_clean)
    setSprint_mode(tempSprint_mode)
  }, [measurementMineral, commonMineral, id, data])


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: measurementMineral?.id,
      mineral_id: measurementMineral?.mineral_id,
      mineral_code: measurementMineral?.mineral_code,
      measure_date: measurementMineral?.measure_date,
      variation: measurementMineral?.variation,
      spurt: measurementMineral?.spurt,
      usage_for_day: measurementMineral?.usage_for_day,
      depth: measurementMineral?.depth,

      // sprint_mode: sprint_mode === undefined ? false : sprint_mode,

      sprint_mode_description: measurementMineral?.sprint_mode_description,

      // contains_water: contains_water === undefined ? false : contains_water,

      is_used: measurementMineral?.is_used,
      usage_information: measurementMineral?.usage_information,

      // is_clean: is_clean === undefined ? false : is_clean, 

      sanitary_requirements: measurementMineral?.sanitary_requirements,
      water_physical_quality: measurementMineral?.water_physical_quality,
      rocks_name: measurementMineral?.rocks_name,
      rocks_index_geologicalage: measurementMineral?.rocks_index_geologicalage,
      feature_description: measurementMineral?.feature_description,

      report_autor: measurementMineral?.report_autor,
      report_name: measurementMineral?.report_name,
      report_code: measurementMineral?.report_code,

    },
    validationSchema: Yup.object({
      mineral_code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      measure_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      variation: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      spurt: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      usage_for_day: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      depth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      sprint_mode_description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      is_used: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      usage_information: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      sanitary_requirements: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_physical_quality: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      rocks_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      rocks_index_geologicalage: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      feature_description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      report_autor: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (measurementMineral !== null) {
        const updateList = {
          id: measurementMineral?.id,
          mineral_id: measurementMineral?.mineral_id,

          mineral_code: values?.mineral_code,
          measure_date: values?.measure_date,
          variation: values?.variation,
          spurt: values?.spurt,
          usage_for_day: values?.usage_for_day,
          depth: values?.depth,

          sprint_mode: sprint_mode === undefined ? false : sprint_mode,
          sprint_mode_description: values?.sprint_mode_description,
          contains_water: contains_water === undefined ? false : contains_water,
          is_used: values?.is_used,
          usage_information: values?.usage_information,
          is_clean: is_clean === undefined ? false : is_clean,
          sanitary_requirements: values?.sanitary_requirements,
          water_physical_quality: values?.water_physical_quality,
          rocks_name: values?.rocks_name,
          rocks_index_geologicalage: values?.rocks_index_geologicalage,
          feature_description: values?.feature_description,

          report_autor: values?.report_autor,
          report_name: values?.report_name,
          report_code: values?.report_code,
        }
        // console.log(updateList);

        measurementMineralUpdate(updateList);
      } else {
        const newList = {
          mineral_id: id,
          mineral_code: values["mineral_code"],
          measure_date: values["measure_date"],
          variation: values["variation"],
          spurt: values["spurt"],
          usage_for_day: values["usage_for_day"],
          depth: values["depth"],

          sprint_mode: sprint_mode === undefined ? false : sprint_mode,
          sprint_mode_description: values["sprint_mode_description"],
          contains_water: contains_water === undefined ? false : contains_water,
          is_used: values["is_used"],
          usage_information: values["usage_information"],
          is_clean: is_clean === undefined ? false : is_clean,
          sanitary_requirements: values["sanitary_requirements"],
          water_physical_quality: values["water_physical_quality"],
          rocks_name: values["rocks_name"],
          rocks_index_geologicalage: values["rocks_index_geologicalage"],
          feature_description: values["feature_description"],

          report_autor: values["report_autor"],
          report_name: values["report_name"],
          report_code: values["report_code"],
        };

        measurementMineralCreate(newList)
      }
      validation.resetForm();
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (

    <>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={measurementSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label"
              onClick={() => {
                validation.resetForm();
                setMeasurementMineral(null);
                setIs_cleanBoolean(false);
                setSprint_mode(false);
                setContains_waterBoolean(false)
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>

          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setMeasurementMineral(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="fw-semibold"> Рашааны дугаар </Label>
                      <Input
                        name="mineral_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.mineral_code || ""}
                        invalid={
                          validation.touched.mineral_code &&
                            validation.errors.mineral_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.mineral_code &&
                        validation.errors.mineral_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.mineral_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Рашааны ундарга, л/с  </Label>
                      <Input
                        name="spurt"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.spurt || ""}
                        invalid={
                          validation.touched.spurt &&
                            validation.errors.spurt
                            ? true
                            : false
                        }
                      />
                      {validation.touched.spurt &&
                        validation.errors.spurt ? (
                        <FormFeedback type="invalid">
                          {validation.errors.spurt}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Энэ нь ширэгдэг бол </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setSprint_mode(!sprint_mode);
                        }}
                        checked={sprint_mode}
                      />
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглаж байгаа эсэх  </Label>
                      <Input
                        name="is_used"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.is_used || ""}
                        invalid={
                          validation.touched.is_used &&
                            validation.errors.is_used
                            ? true
                            : false
                        }
                      >
                        <option disabled value="">Сонгох</option>
                        <option value="null">Мэдэхгүй</option>
                        <option value="true">Ашиглаж байгаа</option>
                        <option value="false">Ашиглаагүй</option>

                      </Input>
                      {validation.touched.is_used &&
                        validation.errors.is_used ? (
                        <FormFeedback type="invalid">
                          {validation.errors.is_used}
                        </FormFeedback>
                      ) : null}
                    </div>


                    <div className="mb-3">
                      <Label className="fw-semibold"> Ариун цэвэр,эрүүл ахуйн шаардлага хангалт  </Label>
                      <Input
                        name="sanitary_requirements"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.sanitary_requirements || ""}
                        invalid={
                          validation.touched.sanitary_requirements &&
                            validation.errors.sanitary_requirements
                            ? true
                            : false
                        }
                      />
                      {validation.touched.sanitary_requirements &&
                        validation.errors.sanitary_requirements ? (
                        <FormFeedback type="invalid">
                          {validation.errors.sanitary_requirements}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Чулуулгийн геологийн насны индекс </Label>
                      <Input
                        name="rocks_index_geologicalage"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.rocks_index_geologicalage || ""}
                        invalid={
                          validation.touched.rocks_index_geologicalage &&
                            validation.errors.rocks_index_geologicalage
                            ? true
                            : false
                        }
                      />
                      {validation.touched.rocks_index_geologicalage &&
                        validation.errors.rocks_index_geologicalage ? (
                        <FormFeedback type="invalid">
                          {validation.errors.rocks_index_geologicalage}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн нэр  </Label>
                      <Input
                        name="report_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_name || ""}
                        invalid={
                          validation.touched.report_name &&
                            validation.errors.report_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_name &&
                        validation.errors.report_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_name}
                        </FormFeedback>
                      ) : null}
                    </div>



                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Рашааны хэрэглээ, м3/ хоног.(хүн/хоног) </Label>
                      <Input
                        name="usage_for_day"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_for_day || ""}
                        invalid={
                          validation.touched.usage_for_day &&
                            validation.errors.usage_for_day
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_for_day &&
                        validation.errors.usage_for_day ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_for_day}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ширэгдэг эсэх тайлбар </Label>
                      <Input
                        name="sprint_mode_description"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.sprint_mode_description || ""}
                        invalid={
                          validation.touched.sprint_mode_description &&
                            validation.errors.sprint_mode_description
                            ? true
                            : false
                        }
                      />
                      {validation.touched.sprint_mode_description &&
                        validation.errors.sprint_mode_description ? (
                        <FormFeedback type="invalid">
                          {validation.errors.sprint_mode_description}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглалтын (хэрэглээний) талаарх мэдээлэл    </Label>
                      <Input
                        name="usage_information"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_information || ""}
                        invalid={
                          validation.touched.usage_information &&
                            validation.errors.usage_information
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_information &&
                        validation.errors.usage_information ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_information}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Усны физик чанар </Label>
                      <Input
                        name="water_physical_quality"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_physical_quality || ""}
                        invalid={
                          validation.touched.water_physical_quality &&
                            validation.errors.water_physical_quality
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_physical_quality &&
                        validation.errors.water_physical_quality ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_physical_quality}
                        </FormFeedback>
                      ) : null}
                    </div>



                    <div className="mb-3">
                      <Label className="fw-semibold"> гадаргуугийн онцлог хэв шинжийн талаарх мэдээлэл </Label>
                      <Input
                        name="feature_description"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.feature_description || ""}
                        invalid={
                          validation.touched.feature_description &&
                            validation.errors.feature_description
                            ? true
                            : false
                        }
                      />
                      {validation.touched.feature_description &&
                        validation.errors.feature_description ? (
                        <FormFeedback type="invalid">
                          {validation.errors.feature_description}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн фондын бүртгэлийн дугаар  </Label>
                      <Input
                        name="report_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_code || ""}
                        invalid={
                          validation.touched.report_code &&
                            validation.errors.report_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_code &&
                        validation.errors.report_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_code}
                        </FormFeedback>
                      ) : null}
                    </div>


                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ундаргын хэлбэлзэл, л/с </Label>
                      <Input
                        name="variation"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.variation || ""}
                        invalid={
                          validation.touched.variation &&
                            validation.errors.variation
                            ? true
                            : false
                        }
                      />
                      {validation.touched.variation &&
                        validation.errors.variation ? (
                        <FormFeedback type="invalid">
                          {validation.errors.variation}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Гүн </Label>
                      <Input
                        name="depth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.depth || ""}
                        invalid={
                          validation.touched.depth &&
                            validation.errors.depth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.depth &&
                        validation.errors.depth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.depth}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Устай эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setContains_waterBoolean(!contains_water);
                        }}
                        checked={contains_water}
                      />
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Эрүүл ахуйн шаардлага хангасан эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_cleanBoolean(!is_clean);
                        }}
                        checked={is_clean}
                      />
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Ус агуулагч чулуулгийн нэр  </Label>
                      <Input
                        name="rocks_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.rocks_name || ""}
                        invalid={
                          validation.touched.rocks_name &&
                            validation.errors.rocks_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.rocks_name &&
                        validation.errors.rocks_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.rocks_name}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлан зохиогчийн нэр   </Label>
                      <Input
                        name="report_autor"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_autor || ""}
                        invalid={
                          validation.touched.report_autor &&
                            validation.errors.report_autor
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_autor &&
                        validation.errors.report_autor ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_autor}
                        </FormFeedback>
                      ) : null}
                    </div>


                  </Col>
                  <Col lg={12} className="d-flex justify-content-center mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>
      </Row>
    </>
  )
}

export default Measurement;